import React from 'react';
import ConfirmationDialog, { ConfirmFacts } from '../../common/ConfirmationDialog';
import { SheetTally } from './useMarksSheet';

/** The last look before a sheet is submitted: what it holds, and that it locks. */
const SubmitMarksDialog: React.FC<{
  open: boolean;
  subject: string;
  tally: SheetTally;
  /** Papers this submit will lock. */
  papers: number;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}> = ({ open, subject, tally, papers, loading, onClose, onConfirm }) => (
  <ConfirmationDialog
    open={open}
    onClose={loading ? () => undefined : onClose}
    onConfirm={onConfirm}
    title={`Submit ${subject} marks?`}
    message={`${papers} paper${papers === 1 ? '' : 's'} will be locked. After this, only someone allowed to unlock marks can change them.`}
    confirmText="Submit & lock"
    confirmColor="primary"
    loading={loading}
  >
    <ConfirmFacts
      items={[
        { label: 'Marked present', value: tally.present },
        ...(tally.absent ? [{ label: 'Absent', value: tally.absent }] : []),
        ...(tally.notAppeared ? [{ label: 'Not appeared', value: tally.notAppeared }] : []),
        ...(tally.average !== null ? [{ label: 'Average', value: `${tally.average.toFixed(1)}%` }] : []),
      ]}
    />
  </ConfirmationDialog>
);

export default SubmitMarksDialog;
